import axios from 'axios';

export default axios.create({
    baseURL:'https://mhis-backend.vercel.app/api/',
    //baseURL:'https://web.millergroup.it/api/'
});


//https://web.millergroup.it/api/

//http://localhost:3000/api/